import { render } from "./CategoryShops.vue?vue&type=template&id=347757ae&scoped=true"
import script from "./CategoryShops.vue?vue&type=script&lang=js"
export * from "./CategoryShops.vue?vue&type=script&lang=js"

import "./CategoryShops.vue?vue&type=style&index=0&id=347757ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347757ae"]])

export default __exports__